import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './layouts/AppShell';
import { KioskPage } from './pages/kiosk/KioskPage';
import { DashboardPage } from './pages/DashboardPage';
import { VehiclesPage } from './pages/vehicles/VehiclesPage';
import { VehicleDetailPage } from './pages/vehicles/VehicleDetailPage';
import { OrdersPage } from './pages/orders/OrdersPage';
import { ComprasPage } from './pages/orders/ComprasPage';
import { PartRequestDetailPage } from './pages/orders/PartRequestDetailPage';
import { PedidoDetailPage } from './pages/orders/PedidoDetailPage';
import { PartsPage } from './pages/parts/PartsPage';
import { PartDetailPage } from './pages/parts/PartDetailPage';
import { ScannerPage } from './pages/parts/ScannerPage';
import { AssistantPage } from './pages/AssistantPage';
import { UsersPage } from './pages/UsersPage';

export function App() {
  return (
    <Routes>
      <Route path="/kiosk" element={<KioskPage />} />

      <Route path="/shop" element={<AppShell mode="shop" />}>
        <Route index element={<OrdersPage touch />} />
        <Route path="compras" element={<ComprasPage touch />} />
        <Route path="compras/pedido/:orderId" element={<PedidoDetailPage />} />
        <Route path="compras/:osId/:prId" element={<PartRequestDetailPage />} />
        <Route path="scanner" element={<ScannerPage />} />
        <Route path="parts" element={<PartsPage touch />} />
        <Route path="parts/:id" element={<PartDetailPage />} />
      </Route>

      <Route path="/admin" element={<AppShell mode="admin" />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="vehicles" element={<VehiclesPage />} />
        <Route path="vehicles/:id" element={<VehicleDetailPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="compras" element={<ComprasPage />} />
        <Route path="compras/pedido/:orderId" element={<PedidoDetailPage />} />
        <Route path="compras/:osId/:prId" element={<PartRequestDetailPage />} />
        <Route path="parts" element={<PartsPage />} />
        <Route path="parts/:id" element={<PartDetailPage />} />
        <Route path="scanner" element={<ScannerPage />} />
        <Route path="assistant" element={<AssistantPage />} />
        <Route path="users" element={<UsersPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
